import CommonPricePlanCalculator from 'common/components/entities/PricePlanCalculator'
import PricePlanCalculatorInterface from 'common/types/entities/PricePlanCalculatorInterface'
import pageSelectors from 'publisher/store/page/pageSelectors'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useRemoveUnavailablePopups } from 'src/publisher/hooks/use-remove-unavailable-popups'
import { showPopup } from '../../actionsManagement'
import { optInSelectors, useOptIn, usePage } from '../../store'

type PricePlanSliderProps = {
  entity: PricePlanCalculatorInterface
}

function PricePlanCalculator({ entity }: PricePlanSliderProps) {
  const dispatch = useDispatch()
  const countryCode = useOptIn(optInSelectors.getCustomerCountry)
  const pageLocale = usePage(pageSelectors.getLocale)

  function handleOpenPopup() {
    dispatch(showPopup(entity.popupId))
  }

  useRemoveUnavailablePopups({
    entity,
    removeType: 'setToNull',
  })

  return (
    <CommonPricePlanCalculator
      openPopup={handleOpenPopup}
      locale={pageLocale}
      countryCode={countryCode}
    />
  )
}

export default PricePlanCalculator
